import * as Sentry from '@sentry/nextjs';

import type { Career } from '@/types/Content/Career';

import { api } from './api';

interface Values {
  name: string;
  job_title: string;
  email: string;
  phone_number: string;
  country: string;
  company_name: string;
  number_of_employees: number;
  industry?: string;
  message?: string;
}

interface ResponseData extends Omit<Values, 'industry' | 'message'> {
  id: string;
  created_at: string;
  updated_at: string;
  industry: string;
  message: string;
}

type CareersResponseData = {
  items: Career[];
  has_next: boolean;
  has_previous: boolean;
  total: number;
  params: {
    page?: number;
    limit?: number;
  };
};

const contactUsService = {
  send(values: Values) {
    return api
      .post<ResponseData>('/contact-us/submission', values)
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        Sentry.captureException(error);
        throw error;
      });
  },

  getCareers(
    { page = 1, limit = 100 }: { page?: number; limit?: number } = {
      page: 1,
      limit: 100,
    },
  ) {
    const params = { page, limit };

    return api
      .get<CareersResponseData>('/contact-us/careers', {
        params,
      })
      .then(({ data }) => {
        return { ...data, params };
      })
      .catch((error) => {
        Sentry.captureException(error);
        throw error;
      });
  },
};

export default contactUsService;
